<app-skeleton class="edit-template-rightSec-loader" *ngIf="generalpopup" [section]="'edit_template_rightmenu'" [loop]="0"></app-skeleton>
<ng-container *transloco="let t;">
<div *ngIf="!generalpopup && attachmentData">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center content-sidebar-header py-75 px-1 mt-50">
        <div class="linked-organization-inner">
            <div class="d-flex justify-content-start align-items-center">
                <div class="user-page-info">
                    <h5 class="mb-0">
                        @if(attachmentData.type == "attachment"){
                            {{t("Attachment setting title (Template/Document - section) - Attachment Setting")}}
                        }@else {
                            {{t("Upload PDF setting title (Template/Document - section) - Upload PDF Setting")}}
                        }                       
                    </h5>
                </div>
            </div>
        </div>
        <div class="cursor-pointer" (click)="close()">
            <i data-feather="x" [size]="16" class="ms-0"></i>
        </div>
    </div>
    <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="attachmentSetting-scroll-content-container">
        <div class="">
        @if(attachmentData.type == "attachment"){
        <div class="form-group px-1">
            <label class="col-form-label pt-0" for="name">{{t("Field settings tield type (Template/Document - section) - Field type")}}</label>

            <div class="custum-dropdown-field-type" >
                <ng-select #field_type
                        bindLabel="name" bindValue="prefixid" [(ngModel)]="selectedAttachmentField" [items]="fieldtype" [placeholder]='t("Field settings select field type (Template/Document - section) - Select field type")' [clearable]="false" (change)="onSelectTypeChange($event)"
                >
                    <ng-template ng-option-tmp ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">
                        <div class="d-flex justify-content-between align-items-center">
                            <span class="ng-value-label field-type-value">{{ item.name }}</span>
                            <span class="field-type-label" [style.color] = "item?.color ? item.color : ''">{{ item.field_type }}</span>
                        </div>
                            
                    </ng-template>
                </ng-select>
            </div>
        </div>
        <div class="form-group px-1">
            <label class="col-form-label pt-0" for="basicInput">{{t("Field settings Rename name label (Template/Document - section) - Label")}}</label>
            <input type="text" class="form-control" id="basicInput"
                (keyup)="renameLabel($event)" [(ngModel)]="attachmentData.attachment_name"/>
        </div>
        }@else {
        <div class="form-group px-1 attachment-autocomplete">
            <label class="col-form-label pt-0" for="name">{{t("Attachment settings name label (Template/Document - section) - Name of attachment")}}</label>
            <div class="ng-autocomplete">
                <ng-autocomplete [(ngModel)]="attachmentData.attachment_name" [data]="[]" [searchKeyword]="keyword" (inputChanged)='onChangeSearch($event)' [itemTemplate]="itemTemplate" (inputCleared)="onChangeSearch('')">
                </ng-autocomplete>

                <ng-template #itemTemplate let-item>
                    <a [innerHTML]="item.name"></a>
                </ng-template>
            </div>
        </div>
        }

        <div class="form-group px-1">
            <label class="col-form-label pt-0" for="name">{{t("Attachment settings request from label (Template/Document - section) - Request from")}}</label>
            <ng-select (change)="onChangeRole($event)" [items]="generalPopoverSettings.selectRole" [clearable]="false" bindLabel="name" bindValue="id" [(ngModel)]="attachmentData.request_from" [placeholder]="t('Select empty placeholder (drop down list) - select')">
                <ng-template ng-notfound-tmp>
                    <div class="ng-option ng-option-disabled">
                        {{t('Template editor - Attachment block Settings - Conditional droplist - No item found')}}
                    </div>
                </ng-template>
            </ng-select>
        </div>
        <div class="form-group px-1">
            <label class="col-form-label pt-0" for="name">{{t("Attachment settings upload is label (Template/Document - section) - Upload is")}}</label>
            <ng-select [items]="uploadingOptions" [clearable]="false" bindLabel="name" bindValue="id" [(ngModel)]="attachmentData.uploading_is" [placeholder]="t('Select empty placeholder (drop down list) - select')" (change)="uploadingIs($event)">
                <ng-template ng-notfound-tmp>
                    <div class="ng-option ng-option-disabled">
                        {{t('Template editor - Attachment block Settings - Conditional droplist - No item found')}}
                    </div>
                </ng-template>
            </ng-select>
        </div>
        @if(attachmentData.type == "attachment"){
        <div class="form-group px-1">
            <label class="col-form-label pt-0" for="name">{{t("Attachment settings viewing is label (Template/Document - section) - Viewing is")}}
                <i class="feather icon-alert-circle ms-50" placement="top" container="body" placement="auto" [autoClose]="true" triggers="hover" [ngbTooltip]="t('Attachment viewing validation tooltip (form validation) - Select if you want your recipient to view the attachment before the can complete their signature/approval')"></i>
            </label>
            <ng-select [items]="uploadingOptions" [clearable]="false" bindLabel="name" bindValue="id" [(ngModel)]="attachmentData.viewing_is" [placeholder]="t('Select empty placeholder (drop down list) - select')" (change)="viewingIs($event)">
                <ng-template ng-notfound-tmp>
                    <div class="ng-option ng-option-disabled">
                        {{t('Template editor - Attachment block Settings - Conditional droplist - No item found')}}
                    </div>
                </ng-template>
            </ng-select>
        </div>
        }

        <div class="px-1">
            <hr class="mb-50 mt-1" />
        </div>
        <div class="form-group px-1 mt-50 conditional-dropdown">
            <app-conditional-fields
                [uuid]="data['uuid']"
                [block]="attachmentData"
            ></app-conditional-fields>
        </div>
    </div>
    <app-lock-field 
        type="block"
        [uuid]="data['uuid']"
        >
    </app-lock-field>
    </ng-scrollbar>
    
</div>
</ng-container>
